import { TextKeyValuePair } from '@/components/atomic/atoms';
import { TextWithIcon } from '@/components/atomic/nuclei';
import { parseFormatPriceNumberValueFromAPI } from '@/lib/numberStringUtils';
import { useIsMobile } from '@/lib/screenResolution';

const ProductCardSummary = ({
  maxInventory,
  name,
  shortDescription,
  unitPartnerPrice
}) => {
  const [isMobile] = useIsMobile();
  return (
    <div className='flex flex-col p-3'>
      <TextKeyValuePair
        {...{
          className: `flex-col !gap-1 ${isMobile ? 'items-start' : ''}`,
          label: name,
          labelClass: 'font-medium md:max-w-80 max-w-72 truncate',
          spaceTop: '',
          value: shortDescription,
          valueClassName:
            'text-xs text-brand mb-1 font-medium md:max-w-80 max-w-72 truncate'
        }}
      />
      <div className='my-3 border-t' />
      <div className='flex flex-col gap-2 text-sm text-dim-gray font-medium'>
        <TextWithIcon
          {...{
            alt: 'product quantity icon',
            className: 'flex gap-1',
            icon: 'quantity.svg',
            iconHeight: 20,
            iconStyle: 'rounded-lg',
            iconWidth: 20,
            label: `Qty: ${maxInventory}`,
            labelStyle: 'max-w-72 truncate'
          }}
        />
        <TextWithIcon
          {...{
            alt: 'product price icon',
            className: 'flex gap-1',
            icon: 'unit-partner-price.svg',
            iconHeight: 20,
            iconStyle: 'rounded-lg',
            iconWidth: 20,
            label:
              unitPartnerPrice > 0
                ? `AED ${parseFormatPriceNumberValueFromAPI(unitPartnerPrice)} /Unit price`
                : 'Not Available',
            labelStyle: 'max-w-72 truncate'
          }}
        />
      </div>
    </div>
  );
};

export default ProductCardSummary;
